import {
    DialogProvider,
    Dialog,
    DialogDismiss,
    DialogBody,
    DialogHeader,
    DialogHeading
} from '@/components/ui/dialog-atoms/DialogAtoms'
import {useTranslation} from '@/translations/i18n'
import {DialogStore} from '@ariakit/react'
import {FC} from 'react'
import {AddConsultantAbsenceFields} from '../add-consultant-absence-fields/AddConsultantAbsenceFields'
import {AddConsultantAbsenceDialogFooter} from '../add-consultant-absence-dialog-footer/AddConsultantAbsenceDialogFooter'
import {UserSmall} from '@/features/users/types'
import {zodResolver} from '@hookform/resolvers/zod'
import {AddConsultantAbsenceFormValidationSchema} from '../../formSchemas'
import {useForm, FormProvider} from 'react-hook-form'

interface AddConsultantAbsenceDialogProps {
    dialogStore: DialogStore
    selectedConsultant?: Pick<UserSmall, 'id' | 'fullName'> | null
}

export const AddConsultantAbsenceDialog: FC<AddConsultantAbsenceDialogProps> = ({dialogStore, selectedConsultant}) => {
    return (
        <DialogProvider store={dialogStore}>
            <Dialog width="680px" overflowY="unset">
                <DialogContent dialogStore={dialogStore} selectedConsultant={selectedConsultant} />
            </Dialog>
        </DialogProvider>
    )
}

const DialogContent = ({selectedConsultant}: AddConsultantAbsenceDialogProps) => {
    const {t} = useTranslation()

    const form = useForm<AddConsultantAbsenceFormValidationSchema>({
        resolver: zodResolver(AddConsultantAbsenceFormValidationSchema),
        defaultValues: {
            consultant: selectedConsultant || undefined
        }
    })

    return (
        <>
            <DialogHeader>
                <DialogHeading>{t('agenda:add_consultant_absence')}</DialogHeading>
                <DialogDismiss />
            </DialogHeader>
            <FormProvider {...form}>
                <DialogBody>
                    <AddConsultantAbsenceFields />
                </DialogBody>
                <AddConsultantAbsenceDialogFooter />
            </FormProvider>
        </>
    )
}
